import React, { useEffect, useState } from "react";
import Specifications from "./Specifications";
import styles from "./IntroSection.module.scss";
import { Container, Grid } from "semantic-ui-react";
import ImageGallery from "./ImageGallery";
import { useDispatch, useSelector } from "react-redux";
import { getPatternById } from "../../../actions/patternActions";
import { getProfileById } from "../../../actions/profileActions";
import Description from "./Description";
import isEmpty from "../../../validation/is-empty";
import ManagePatternButtons from "./ManagePatternButtons";
import {
  authSelector,
  patternSelector,
  profileSelector,
} from "../../../utils/selectors";
import Spinner from "../../../components/Spinner";
import { getSamplePatternById } from "../../../utils/samplePatterns";

type Props = {
  patternId: string;
};

const IntroSection: React.FC<Props> = ({ patternId }) => {
  const dispatch = useDispatch();
  const [usingSample, setUsingSample] = useState(false);

  const { user } = useSelector((state) => authSelector(state));
  const { pattern: reduxPattern, loading, error } = useSelector((state) => patternSelector(state));
  const profile = useSelector((state) => profileSelector(state));

  // Get sample pattern as fallback
  const samplePattern = getSamplePatternById(patternId);
  const pattern = (reduxPattern && !error) ? reduxPattern : samplePattern;

  useEffect(() => {
    dispatch(getPatternById(patternId));
  }, [patternId, dispatch]);

  useEffect(() => {
    if (error && samplePattern) {
      setUsingSample(true);
    }
  }, [error, samplePattern]);

  useEffect(() => {
    if (pattern && pattern.user && !usingSample) {
      dispatch(getProfileById(pattern.user));
    }
  }, [pattern, dispatch, usingSample]);

  const displayDescription = () => {
    return (
      !isEmpty(pattern.descriptionLong) ||
      !isEmpty(pattern.categories) ||
      !isEmpty(pattern.clients) ||
      !isEmpty(pattern.fabrics)
    );
  };

  if (loading) {
    return <Spinner />;
  }

  return !isEmpty(pattern) ? (
    <Grid.Row className={styles.self}>
      {pattern && user && pattern.user === user._id && (
        <Container>
          <ManagePatternButtons id={patternId} />
        </Container>
      )}
      <Container>
        <Grid>
          {!isEmpty(pattern.photos) && (
            <Grid.Column mobile={16} tablet={8} computer={8}>
              <ImageGallery photos={pattern.photos} />
            </Grid.Column>
          )}
          <Grid.Column mobile={16} tablet={8} computer={8}>
            <Specifications pattern={pattern} profile={profile} />
          </Grid.Column>
        </Grid>

        {displayDescription() && (
          <Grid centered>
            <Grid.Column mobile={16} tablet={14} computer={12} widescreen={12}>
              <Description pattern={pattern} profile={profile?.profile} />
            </Grid.Column>
          </Grid>
        )}
      </Container>
    </Grid.Row>
  ) : null;
};

export default IntroSection;
